// Approximate centroid coordinates [lat, lon] for all 290 Swedish kommuner.
// Used to plot members on the members map by their kommun rather than province
// so members in the same län are scattered geographically rather than stacked
// on the län's capital.

export const municipalityCoords: Record<string, [number, number]> = {
  // Stockholms län
  "Botkyrka": [59.2, 17.83], "Danderyd": [59.4, 18.03], "Ekerö": [59.29, 17.81],
  "Haninge": [59.17, 18.14], "Huddinge": [59.24, 17.98], "Järfälla": [59.42, 17.83],
  "Lidingö": [59.36, 18.13], "Nacka": [59.31, 18.16], "Norrtälje": [59.76, 18.7],
  "Nykvarn": [59.18, 17.42], "Nynäshamn": [58.9, 17.95], "Salem": [59.2, 17.77],
  "Sigtuna": [59.62, 17.72], "Sollentuna": [59.43, 17.95], "Solna": [59.36, 18.0],
  "Stockholm": [59.33, 18.07], "Sundbyberg": [59.36, 17.97], "Södertälje": [59.2, 17.63],
  "Tyresö": [59.24, 18.31], "Täby": [59.44, 18.06], "Upplands Väsby": [59.52, 17.91],
  "Upplands-Bro": [59.52, 17.65], "Vallentuna": [59.53, 18.07], "Vaxholm": [59.4, 18.35],
  "Värmdö": [59.32, 18.5], "Österåker": [59.48, 18.3],

  // Uppsala län
  "Enköping": [59.64, 17.08], "Heby": [59.94, 16.86], "Håbo": [59.61, 17.53],
  "Knivsta": [59.72, 17.79], "Tierp": [60.34, 17.52], "Uppsala": [59.86, 17.64],
  "Älvkarleby": [60.57, 17.45], "Östhammar": [60.26, 18.37],

  // Södermanlands län
  "Eskilstuna": [59.37, 16.51], "Flen": [59.06, 16.59], "Gnesta": [59.04, 17.31],
  "Katrineholm": [58.99, 16.21], "Nyköping": [58.75, 17.01], "Oxelösund": [58.67, 17.1],
  "Strängnäs": [59.38, 17.03], "Trosa": [58.9, 17.55], "Vingåker": [59.04, 15.87],

  // Östergötlands län
  "Boxholm": [58.2, 15.05], "Finspång": [58.71, 15.78], "Kinda": [57.99, 15.62],
  "Linköping": [58.41, 15.63], "Mjölby": [58.33, 15.13], "Motala": [58.54, 15.04],
  "Norrköping": [58.59, 16.18], "Söderköping": [58.48, 16.32], "Vadstena": [58.45, 14.89],
  "Valdemarsvik": [58.2, 16.6], "Ydre": [57.87, 15.18], "Åtvidaberg": [58.2, 15.99],
  "Ödeshög": [58.23, 14.65],

  // Jönköpings län
  "Aneby": [57.84, 14.81], "Eksjö": [57.67, 14.97], "Gislaved": [57.3, 13.54],
  "Gnosjö": [57.36, 13.74], "Habo": [57.91, 14.07], "Jönköping": [57.78, 14.16],
  "Mullsjö": [57.92, 13.88], "Nässjö": [57.65, 14.7], "Sävsjö": [57.4, 14.66],
  "Tranås": [58.04, 14.97], "Vaggeryd": [57.5, 14.15], "Vetlanda": [57.43, 15.07],

  // Kronobergs län
  "Alvesta": [56.9, 14.55], "Lessebo": [56.75, 15.27], "Ljungby": [56.83, 13.94],
  "Markaryd": [56.46, 13.6], "Tingsryd": [56.53, 14.97], "Uppvidinge": [57.04, 15.45],
  "Växjö": [56.88, 14.81], "Älmhult": [56.55, 14.13],

  // Kalmar län
  "Borgholm": [56.88, 16.66], "Emmaboda": [56.63, 15.54], "Hultsfred": [57.49, 15.84],
  "Högsby": [57.17, 16.03], "Kalmar": [56.66, 16.36], "Mönsterås": [57.04, 16.44],
  "Mörbylånga": [56.52, 16.39], "Nybro": [56.74, 15.91], "Oskarshamn": [57.27, 16.45],
  "Torsås": [56.41, 16.0], "Vimmerby": [57.67, 15.85], "Västervik": [57.76, 16.64],

  // Gotlands län
  "Gotland": [57.47, 18.49],

  // Blekinge län
  "Karlshamn": [56.17, 14.86], "Karlskrona": [56.16, 15.59], "Olofström": [56.27, 14.53],
  "Ronneby": [56.21, 15.28], "Sölvesborg": [56.05, 14.59],

  // Skåne län
  "Bjuv": [56.08, 12.92], "Bromölla": [56.07, 14.47], "Burlöv": [55.64, 13.08],
  "Båstad": [56.43, 12.85], "Eslöv": [55.84, 13.3], "Helsingborg": [56.05, 12.69],
  "Hässleholm": [56.16, 13.77], "Höganäs": [56.2, 12.55], "Hörby": [55.85, 13.66],
  "Höör": [55.93, 13.54], "Klippan": [56.13, 13.13], "Kristianstad": [56.03, 14.15],
  "Kävlinge": [55.79, 13.11], "Landskrona": [55.87, 12.83], "Lomma": [55.67, 13.07],
  "Lund": [55.7, 13.19], "Malmö": [55.6, 13.0], "Osby": [56.38, 13.99],
  "Perstorp": [56.14, 13.39], "Simrishamn": [55.55, 14.35], "Sjöbo": [55.63, 13.7],
  "Skurup": [55.47, 13.5], "Staffanstorp": [55.64, 13.21], "Svalöv": [55.91, 13.11],
  "Svedala": [55.51, 13.24], "Tomelilla": [55.55, 13.95], "Trelleborg": [55.38, 13.16],
  "Vellinge": [55.47, 13.02], "Ystad": [55.43, 13.82], "Åstorp": [56.13, 12.95],
  "Ängelholm": [56.24, 12.86], "Örkelljunga": [56.28, 13.28], "Östra Göinge": [56.23, 14.08],

  // Hallands län
  "Falkenberg": [56.9, 12.49], "Halmstad": [56.67, 12.86], "Hylte": [56.99, 13.24],
  "Kungsbacka": [57.49, 12.08], "Laholm": [56.51, 13.04], "Varberg": [57.11, 12.25],

  // Västra Götalands län
  "Ale": [57.92, 12.06], "Alingsås": [57.93, 12.53], "Bengtsfors": [59.03, 12.23],
  "Bollebygd": [57.67, 12.57], "Borås": [57.72, 12.94], "Dals-Ed": [58.93, 11.93],
  "Essunga": [58.18, 12.71], "Falköping": [58.17, 13.55], "Färgelanda": [58.57, 11.99],
  "Grästorp": [58.33, 12.68], "Gullspång": [58.99, 14.1], "Göteborg": [57.71, 11.97],
  "Götene": [58.53, 13.49], "Herrljunga": [58.08, 13.03], "Hjo": [58.31, 14.29],
  "Härryda": [57.65, 12.32], "Karlsborg": [58.53, 14.51], "Kungälv": [57.87, 11.97],
  "Lerum": [57.77, 12.27], "Lidköping": [58.5, 13.16], "Lilla Edet": [58.13, 12.13],
  "Lysekil": [58.27, 11.44], "Mariestad": [58.71, 13.82], "Mark": [57.49, 12.71],
  "Mellerud": [58.7, 12.46], "Munkedal": [58.48, 11.69], "Mölndal": [57.66, 12.01],
  "Orust": [58.17, 11.65], "Partille": [57.74, 12.11], "Skara": [58.39, 13.44],
  "Skövde": [58.39, 13.85], "Sotenäs": [58.42, 11.32], "Stenungsund": [58.07, 11.82],
  "Strömstad": [58.94, 11.18], "Svenljunga": [57.5, 13.11], "Tanum": [58.72, 11.33],
  "Tibro": [58.42, 14.16], "Tidaholm": [58.18, 13.95], "Tjörn": [58.0, 11.6],
  "Tranemo": [57.48, 13.34], "Trollhättan": [58.28, 12.29], "Töreboda": [58.7, 14.13],
  "Uddevalla": [58.35, 11.94], "Ulricehamn": [57.79, 13.41], "Vara": [58.26, 12.95],
  "Vårgårda": [58.04, 12.81], "Vänersborg": [58.38, 12.32], "Åmål": [59.05, 12.7],
  "Öckerö": [57.71, 11.65],

  // Värmlands län
  "Arvika": [59.65, 12.59], "Eda": [59.89, 12.51], "Filipstad": [59.71, 14.17],
  "Forshaga": [59.53, 13.48], "Grums": [59.36, 13.11], "Hagfors": [60.03, 13.69],
  "Hammarö": [59.31, 13.51], "Karlstad": [59.38, 13.5], "Kil": [59.5, 13.31],
  "Kristinehamn": [59.31, 14.11], "Munkfors": [59.83, 13.54], "Storfors": [59.53, 14.27],
  "Sunne": [59.84, 13.14], "Säffle": [59.13, 12.93], "Torsby": [60.14, 13.0],
  "Årjäng": [59.39, 12.13],

  // Örebro län
  "Askersund": [58.88, 14.91], "Degerfors": [59.24, 14.43], "Hallsberg": [59.07, 15.11],
  "Hällefors": [59.78, 14.51], "Karlskoga": [59.33, 14.52], "Kumla": [59.13, 15.14],
  "Laxå": [58.99, 14.62], "Lekeberg": [59.23, 14.86], "Lindesberg": [59.6, 15.23],
  "Ljusnarsberg": [59.96, 15.0], "Nora": [59.52, 15.04], "Örebro": [59.27, 15.21],

  // Västmanlands län
  "Arboga": [59.39, 15.84], "Fagersta": [60.0, 15.79], "Hallstahammar": [59.62, 16.22],
  "Kungsör": [59.42, 16.08], "Köping": [59.51, 15.99], "Norberg": [60.07, 15.93],
  "Sala": [59.92, 16.6], "Skinnskatteberg": [59.83, 15.69], "Surahammar": [59.71, 16.22],
  "Västerås": [59.61, 16.55],

  // Dalarnas län
  "Avesta": [60.15, 16.17], "Borlänge": [60.49, 15.44], "Falun": [60.61, 15.63],
  "Gagnef": [60.58, 15.08], "Hedemora": [60.28, 15.99], "Leksand": [60.73, 15.0],
  "Ludvika": [60.15, 15.19], "Malung-Sälen": [60.68, 13.72], "Mora": [61.0, 14.54],
  "Orsa": [61.12, 14.62], "Rättvik": [60.89, 15.11], "Smedjebacken": [60.14, 15.41],
  "Säter": [60.35, 15.75], "Vansbro": [60.51, 14.22], "Älvdalen": [61.23, 14.04],

  // Gävleborgs län
  "Bollnäs": [61.35, 16.39], "Gävle": [60.67, 17.15], "Hofors": [60.55, 16.28],
  "Hudiksvall": [61.73, 17.11], "Ljusdal": [61.83, 16.09], "Nordanstig": [61.95, 17.07],
  "Ockelbo": [60.89, 16.72], "Ovanåker": [61.43, 15.81], "Sandviken": [60.62, 16.78],
  "Söderhamn": [61.3, 17.06],

  // Västernorrlands län
  "Härnösand": [62.63, 17.94], "Kramfors": [62.93, 17.78], "Sollefteå": [63.17, 17.27],
  "Sundsvall": [62.39, 17.31], "Timrå": [62.49, 17.33], "Ånge": [62.53, 15.66],
  "Örnsköldsvik": [63.29, 18.72],

  // Jämtlands län
  "Berg": [62.78, 14.32], "Bräcke": [62.75, 15.42], "Härjedalen": [62.43, 13.7],
  "Krokom": [63.33, 14.45], "Ragunda": [63.14, 16.11], "Strömsund": [63.85, 15.55],
  "Åre": [63.4, 13.08], "Östersund": [63.18, 14.64],

  // Västerbottens län
  "Bjurholm": [63.93, 19.16], "Dorotea": [64.26, 16.42], "Lycksele": [64.6, 18.67],
  "Malå": [65.19, 18.74], "Nordmaling": [63.57, 19.5], "Norsjö": [64.92, 19.49],
  "Robertsfors": [64.2, 20.84], "Skellefteå": [64.75, 20.95], "Sorsele": [65.53, 17.54],
  "Storuman": [64.96, 17.11], "Umeå": [63.83, 20.26], "Vilhelmina": [64.62, 16.66],
  "Vindeln": [64.21, 19.72], "Vännäs": [63.91, 19.76], "Åsele": [64.16, 17.36],

  // Norrbottens län
  "Arjeplog": [66.05, 17.89], "Arvidsjaur": [65.59, 19.18], "Boden": [66.0, 21.69],
  "Gällivare": [67.13, 20.65], "Haparanda": [65.84, 24.14], "Jokkmokk": [66.61, 19.83],
  "Kalix": [65.85, 23.16], "Kiruna": [67.86, 20.23], "Luleå": [65.58, 22.15],
  "Pajala": [66.98, 23.37], "Piteå": [65.32, 21.48], "Älvsbyn": [65.68, 21.0],
  "Överkalix": [66.33, 22.84], "Övertorneå": [66.39, 23.65],
};

/**
 * Resolve a profile's location to coordinates.
 * Prefers explicit municipality, falls back to parsing the location string,
 * and as a last resort uses the province's largest city.
 */
export function resolveCoords(opts: {
  municipality?: string | null;
  location?: string | null;
}): [number, number] | null {
  const { municipality, location } = opts;
  if (municipality && municipalityCoords[municipality]) {
    return municipalityCoords[municipality];
  }
  if (!location) return null;
  // location may be "Kommun, Län" — try the first part
  const first = location.split(",")[0].trim();
  if (municipalityCoords[first]) return municipalityCoords[first];
  // Match any kommun name appearing inside the string
  for (const [name, coords] of Object.entries(municipalityCoords)) {
    if (location.toLowerCase().includes(name.toLowerCase())) return coords;
  }
  return null;
}

/**
 * Deterministic small jitter (~3-5 km) so multiple members in the same kommun
 * don't render exactly on top of each other.
 */
export function jitterCoords(
  coords: [number, number],
  seed: string
): [number, number] {
  let h = 0;
  for (let i = 0; i < seed.length; i++) {
    h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  }
  const r1 = ((h & 0xffff) / 0xffff - 0.5) * 0.05; // ~±2.7 km lat
  const r2 = (((h >>> 16) & 0xffff) / 0xffff - 0.5) * 0.08; // ~±2.5 km lon
  return [coords[0] + r1, coords[1] + r2];
}
